import { COMPOSITION_BUFFER_MODE, DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Directive, ElementRef, HostListener, Inject, Optional, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input[appTrTrim], textarea[appTrTrim]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TrimInputValueDirective,
      multi: true
    }
  ]
})
export class TrimInputValueDirective extends DefaultValueAccessor {
  public constructor(renderer: Renderer2, elementRef: ElementRef, @Optional() @Inject(COMPOSITION_BUFFER_MODE) compositionMode: boolean) {
    super(renderer, elementRef, compositionMode);
  }

  @HostListener('input', ['$any($event.target).value'])
  public ngOnChange: (value: string) => void = (value: string): void => {
    this.onChange(value.trim());
  };

  @HostListener('blur', ['$any($event.target).value'])
  public applyTrim(value: string): void {
    this.writeValue(value.trim());
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  public override writeValue(value: any): void {
    if (typeof value === 'string') {
      value = value.trim();
    }

    super.writeValue(value);
  }
}
